// extracted by mini-css-extract-plugin
export default {"modal":"YesNoModal_modal__LRNJT","content":"YesNoModal_content__fleUh","title":"YesNoModal_title__tUaSp","buttons":"YesNoModal_buttons__nzY5D"};